import { useCallback, useMemo, useState } from "react";
import { Position as FlyoutPosition } from "../../flyout/types";
import { POSITIONS } from "../constants";
import { DropdownProps } from "../types";
import { mapAlign } from "../utils";

type UsePositionOptions = Required<Pick<DropdownProps, "align">>;

export const useDropdownPosition = ({ align }: UsePositionOptions) => {
  const mappedAlign = mapAlign(align);
  const alignedPositions: FlyoutPosition[] = useMemo(
    () =>
      Object.values(POSITIONS).map(
        (dropdownPosition) => `${dropdownPosition}-${mappedAlign}` as const
      ),
    [mappedAlign]
  );

  const [position, setPosition] = useState<FlyoutPosition>(alignedPositions[0]);

  const handleHide = () => {
    setPosition(alignedPositions[0]);
  };

  const handleChangePosition = useCallback(
    (position: FlyoutPosition) => {
      if (
        alignedPositions.some((allowedPosition) =>
          allowedPosition.includes(position)
        )
      ) {
        setPosition(position);
      }
    },
    [alignedPositions]
  );

  const flyoutPositions: FlyoutPosition[] = useMemo(
    () => [
      `${POSITIONS.BOTTOM}-${mappedAlign}`,
      `${POSITIONS.TOP}-${mappedAlign}`,
    ],
    [mappedAlign]
  );

  return { flyoutPositions, handleChangePosition, handleHide, position };
};
